import React, {useState} from 'react';

import Conf from 'utils/Conf';

const INTROS = [`${Conf.assetsRoot}/countdown.mp4`, `${Conf.assetsRoot}/25eh.mp4`];

const SeanceIntro = ({onEnd}) => {
  const [currentIntroIndex, setCurrentIntroIndex] = useState(0);

  const handleIntroEnd = () => {
    if (INTROS.length === currentIntroIndex + 1) {
      if (onEnd) onEnd();
      return;
    }
    setCurrentIntroIndex(currentIntroIndex + 1);
  };

  const currentIntro = INTROS[currentIntroIndex];
  return (
    <div className="video-player-container">
      <video className="video-player-intro" autoPlay playsInline src={currentIntro} onEnded={handleIntroEnd} />
    </div>
  );
};

export default SeanceIntro;
